export const roundValue = (value: number): string => value.toFixed(0);
